<template>
	<div class="private-order-banner-container">
		<div class="private-order-banner">
			<img
				src="https://cdn.ostock.id/img/wholesale-order-title-desc.webp"
				alt=""
				class="banner-title"
			/>

			<div class="banner-search-wrapper">
				<private-order-search-bar v-if="searchBarPos === 'page'" placeholder="Cari Produk" />
			</div>

			<img
				class="banner-image"
				alt=""
			/>
		</div>
		<div class="private-order-banner-skeleton skeleton"></div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import PrivateOrderSearchBar from '@/components/private-orders/homepage/SearchBar.vue';

export default {
	components: {
		PrivateOrderSearchBar,
	},
	computed: {
		...mapGetters({
			searchBarPos: 'privateOrder/searchBarPos',
		}),
	},
	methods: {
		async getBannerImage() {
			const bannerElement = document.querySelector('.private-order-banner');
			const imgElement = document.querySelector('.banner-image');
			const skeletonElement = document.querySelector('.private-order-banner-skeleton');
			const bannerUrl = 'https://cdn.ostock.id/img/wholesale-banner.webp';

			imgElement.src = bannerUrl;

			try {
				const response = await fetch(bannerUrl);
				if (!response.ok) throw new Error('Failed to load image');

				const blob = await response.blob();
				const imageObjectUrl = URL.createObjectURL(blob);

				imgElement.src = imageObjectUrl;
			} catch (error) {
				console.error('Error loading image:', error);
			}

			bannerElement.style.display = 'flex';
			skeletonElement.style.display = 'none';
		},
	},
	async mounted() {
		await this.getBannerImage();
	},
};
</script>

<style scoped lang="scss">
.private-order-banner {
	position: relative;
	display: none;
	justify-content: center;
}

img.banner-title {
	position: absolute;
	width: 35%;
	top: 18%;
}

.banner-search-wrapper {
	position: absolute;
	top: 74%;
	width: 200px;
	height: 25px;

	@media screen and (min-width: 600px) {
		width: 40%;
		height: 35px;
	}

	@media screen and (min-width: 992px) {
		width: 40%;
		height: 45px;
	}

	@media screen and (min-width: 1200px) {
		height: 55px;
	}
}

img.banner-image {
	width: 100vw;
}

.private-order-banner-skeleton {
	display: block;
	width: 100%;
	height: 400px;

	&.skeleton {
		margin-bottom: 0;
	}
}
</style>
